/* global axios */
import ApiClient from './ApiClient';

class EvaluationAPI extends ApiClient {
  constructor() {
    super('evaluation_settings', { accountScoped: true });
  }

  createEvaluation(payloadBody) {
    return axios.post(`${this.url}`,payloadBody);
  }

 // get item
  getEvaluationsList(params={}) {
    return axios.get(`${this.url}`,{
      params: {
        ...params
      }
    });
  }
  getEvaluationsFilterList(params={}) {
    const {payload,...restParams} = params;
    return axios.post(`${this.url}/filter`,{payload},{
      params: {
        ...restParams
      }
    });
  }

  updateEvaluationById(evaluation_id,payload) {
    return axios.patch(`${this.url}/${evaluation_id}`,payload);
  }
  deleteEvaluationById(evaluation_id,) {
    return axios.delete(`${this.url}/${evaluation_id}`,);
  }

  getEvaluationReports(params={}) {
    return axios.get(`${this.baseUrl()}/evaluation_results`,{
      params: {
        ...params
      }
    });
  }
  getEvaluationReportsFilterList(params={}) {
    const {payload,...restParams} = params;
    return axios.post(`${this.baseUrl()}/evaluation_results/filter`,{payload},{
      params: {
        ...restParams
      }
    });
  }

  getEvaluationReportDetails(evaluation_id) {
    return axios.get(`${this.baseUrl()}/evaluation_results/${evaluation_id}`,);
  }



}

export default new EvaluationAPI();
